export default "__VITE_ASSET__B3WzdTdO__ 600w";